import React from 'react';
import { Div, Typography } from '@icecreamsocial/components';
import { useIntl } from 'react-intl';

export const Footer = ({ termsURL, privacyURL }) => {
	const intl = useIntl();

	/**
	 * localized strings
	 */
	// @ts-expect-error
	const POWERED_BY = intl.formatMessage(
		{
			id: 'footer.poweredBy',
			defaultMessage: `
			Powered by <linkText>Ice Cream Social</linkText>
		`,
			description: 'Branding text.  Please do not translate "Ice Cream Social"',
		},
		{
			linkText: (str) => (
				<Typography.A
					href='https://icecreamsocial.io'
					target='_blank'
					textColor='body'
					visitedTextColor='body'
				>
					Ice Cream Social
				</Typography.A>
			),
		}
	);

	const TERMS_AND_CONDITIONS = intl.formatMessage({
		id: 'footer.termsAndConditions',
		defaultMessage: 'Terms and Conditions',
		description: "Link for our client's terms and conditions",
	});

	const PRIVACY_POLICY = intl.formatMessage({
		id: 'footer.privacyPolicy',
		defaultMessage: 'Privacy Policy',
		description: "Link for our client's privacy policy",
	});

	return (
		<Div
			as='footer'
			backgroundColor='ambientLight'
			borderColor='ambient'
			borderTop='1px solid'
			padding='xlg'
			textAlign='center'
			typoSize='.8em'
		>
			<Div margin={['sm', 'md']}>
				<Typography.Span textColor='ambientDark'>{POWERED_BY}</Typography.Span>
			</Div>
			<Div display='inline-flex' margin={['sm', 'md']} style={{ gap: '12px' }}>
				<Typography.A
					href={termsURL}
					target='_blank'
					textColor='body'
					visitedTextColor='body'
				>
					{TERMS_AND_CONDITIONS}
				</Typography.A>
				<Typography.Span>|</Typography.Span>
				<Typography.A
					href={privacyURL}
					target='_blank'
					textColor='body'
					visitedTextColor='body'
				>
					{PRIVACY_POLICY}
				</Typography.A>
			</Div>
		</Div>
	);
};
